<template>
  <div class="panel granary-panel">
    <div class="chart-box">
      <div ref="chart" class="chart"></div>
    </div>
    <!-- <img
      src="~@/assets/images/granary/xmy/echart2.png"
      alt=""
      class="echarts-img"
    /> -->
  </div>
</template>

<script>
import { loadCircleChart } from "./charts/circleChart";
// import { getTop10 } from "@/api/pzsd";
export default {
  data() {
    return {};
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      this.circleChart = this.$echarts.init(this.$refs.chart);

      const fontSizes = 13;
      const widths = 10;
      const itemGaps = 15;
      let circleData = [
        {
          name: "猪肉",
          value: 392393
        },
        {
          name: "牛肉",
          value: 2851
        },
        {
          name: "羊肉",
          value: 2130
        },
        {
          name: "家禽肉",
          value: 304068
        }
      ];
      loadCircleChart(
        this.circleChart,
        circleData,
        fontSizes,
        widths,
        itemGaps
      );

      window.addEventListener("resize", () => {
        this.circleChart.resize();
      });
      // this.chart = this.$echarts.init(this.$refs.chart);
      // const eData = [
      //   { name: "谷物", value: 44 },
      //   { name: "水果", value: 26 },
      //   { name: "蔬菜", value: 30 }
      // ];
      // loadChart(this.chart, eData);
      // const data = {
      //   year: this.year === "全部" ? "" : this.year,
      //   city: this.city === "广东省" ? "" : this.city,
      //   type: this.flm === "全部" ? "" : this.flm
      // };
      // getTop10(data).then(res => {
      //   // console.log("top10", res);
      //   if (res) {
      //     let slist = [];
      //     let line = [];
      //     res.forEach(ele => {
      //       slist.push(ele.name);
      //       line.push(Number(ele.num));
      //     });
      //     loadChart(this.chart, slist, line);
      //     window.addEventListener("resize", () => {
      //       setTimeout(() => {
      //         this.chart.resize();
      //       }, 300);
      //     });
      //   }
      // });
    }
  }
};
</script>

<style lang="stylus" scoped>
@import '~@/assets/styl/varibles.styl'
.panel
  height 100%
  .chart-box
    width 100%
    height 100%
  .echarts-img
    height 240px
    margin 0 auto
    display block
</style>
